<template>
  <div id="intro" class="basic-layout d-flex align-items-center justify-content-center m-0 bg-white">
    <img id="twoimgintro" src="/img/home_down.gif">
    <img id="oneimgintro" src="/img/home_up.gif">
    <child></child>
  </div>
</template>

<script>

export default {
  name: 'BasicLayout'
}
</script>

<style lang="scss">
.basic-layout {
  color: #636b6f;
  height: 100vh;
  font-weight: 100;
  position: relative;

  .links > a {
    color: #636b6f;
    padding: 0 25px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .1rem;
    text-decoration: none;
    text-transform: uppercase;
  }

  #oneimgintro {
    position: absolute;
    bottom: 100px;
  }

  #twoimgintro {
    position: absolute;
    top: 5px;
  }

}
</style>



// WEBPACK FOOTER //
// resources/js/layouts/basic.vue